<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">ARTHUR, PRINCE OF WALES</span></h1>
<h1 class="title1a">H<span class="small">ENRY</span> VIII’s L<span class="small">OST</span> B<span class="small">ROTHER</span></h1>
<p class="author"><span class="bold">GARETH BENJAMIN STREETER</span></p>
<div class="img_container">
<img alt="Images" src="images/logo.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?665d3fd8